import { TRoomDetail } from '@/entities/room'
import { cn } from '@/shared/lib'

import ReviewGradientStar from '../../asset/review-gradient-star.svg'

type Props = Pick<TRoomDetail, 'reviewScore'> & {
  className?: string
}

export const ReviewScore = ({ reviewScore, className }: Props) => {
  const roundedReviewScore = Math.round(reviewScore * 10) / 10

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <ReviewGradientStar />
      <strong className="typo-display2 font-bold text-black">
        {roundedReviewScore}
      </strong>
    </div>
  )
}
